import React from "react"
import { createIcon } from "@chakra-ui/icons"

export const FRFlag = createIcon({
  displayName: "FRFlag",
  viewBox: "0 0 96 64",
  defaultProps: {
    role: "img",
  },
  path: (
    <>
      <title> France flag</title>
      <path d="M95 1H64V63H95V1Z" fill="#ED2939" />
      <path d="M64 1H32V63H64V1Z" fill="white" />
      <path d="M32 1H1V63H32V1Z" fill="#002395" />
      <path
        d="M0 0V-1H-1V0H0ZM96 0H97V-1H96V0ZM96 64V65H97V64H96ZM0 64H-1V65H0V64ZM0 1H96V-1H0V1ZM95 0V64H97V0H95ZM96 63H0V65H96V63ZM1 64V0H-1V64H1Z"
        fill="#767676"
      />
    </>
  ),
})
